import React, { useEffect, useState } from 'react';
import { ImpersonateStudent } from '@/components/staffer/ImpersonateStudent';
import useGradesTableStore from '@/components/staffer/Scores/GradesTable/store/useGradesTableStore';
import cn from '@/utils/cn';
import { IStudent } from '../../types';

interface StudentCellProps {
  student: IStudent;
  hoveredRow: number;
  rowId: number;
}

export const StudentCell = ({ student, hoveredRow, rowId }: StudentCellProps) => {
  const programId = useGradesTableStore(state => state.programId);
  const stafferId = useGradesTableStore(state => state.stafferId);
  const isImpersonating = useGradesTableStore(state => state.isImpersonating);

  const [hover, setHover] = useState(false);

  useEffect(() => {
    setHover(hoveredRow === rowId);
  }, [hoveredRow]);

  return (
    <div className="tw-w-full tw-h-full tw-flex tw-items-center tw-justify-between">
      {student.first_name} {student.last_name}

      <span className={cn('tw-absolute tw-right-0 tw-top-1/2 -tw-translate-y-1/2', { 'tw-hidden': !hover })}>
        <ImpersonateStudent
          buttonClass="tw-bg-white tw-rounded-full tw-border-none tw-cursor-pointer tw-hidden group-hover:tw-block"
          enabled={!isImpersonating}
          programId={programId}
          stafferId={stafferId}
          student={{ ...student, name: `${student.first_name} ${student.last_name}` }}
          wrapperClass=""
        />
      </span>
    </div>
  );
};

export default StudentCell;
